'use client';

import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
export const SECTION_NAV_BUTTON_CLASS = 'flex size-12 shrink-0 items-center justify-center rounded-full border border-primary-light bg-primary-light transition-colors duration-300 disabled:pointer-events-none disabled:opacity-40 [@media(hover:hover)]:hover:bg-accent [@media(hover:hover)]:hover:text-primary-light';
type SectionNavButtonProps = {
  direction: 'prev' | 'next';
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
};
export function SectionNavButton(t0) {
  const $ = _c(11);
  const {
    direction,
    onClick,
    disabled,
    className
  } = t0;
  const t1 = direction === "prev" ? "Poprzedni slajd" : "Nast\u0119pny slajd";
  let t2;
  if ($[0] !== className) {
    t2 = clsx(SECTION_NAV_BUTTON_CLASS, className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = direction === "prev" ? "rotate-180" : undefined;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M5 12h14M13 6l6 6-6 6" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t3) {
    t5 = <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden={true} className={t3}>{t4}</svg>;
    $[3] = t3;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== disabled || $[6] !== onClick || $[7] !== t1 || $[8] !== t2 || $[9] !== t5) {
    t6 = <button type="button" onClick={onClick} disabled={disabled} aria-label={t1} className={t2}>{t5}</button>;
    $[5] = disabled;
    $[6] = onClick;
    $[7] = t1;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
type SectionNavButtonsProps = {
  onPrev: () => void;
  onNext: () => void;
  disabled?: boolean;
  className?: string;
};
export function SectionNavButtons(t0) {
  const $ = _c(12);
  const {
    onPrev,
    onNext,
    disabled,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("flex shrink-0 gap-2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== disabled || $[3] !== onPrev) {
    t2 = <SectionNavButton direction="prev" onClick={onPrev} disabled={disabled} />;
    $[2] = disabled;
    $[3] = onPrev;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== disabled || $[6] !== onNext) {
    t3 = <SectionNavButton direction="next" onClick={onNext} disabled={disabled} />;
    $[5] = disabled;
    $[6] = onNext;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}